import { render } from "./TabletRegister.vue?vue&type=template&id=e013874e"
import script from "./TabletRegister.vue?vue&type=script&lang=js"
export * from "./TabletRegister.vue?vue&type=script&lang=js"

import "./TabletRegister.vue?vue&type=style&index=0&id=e013874e&lang=css"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__